import { render } from "./IconMemoCircleCheckClassicSolid.vue?vue&type=template&id=166b79ce"
const script = {}

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__